<div class="user-public-div">
    <div class="titleLoginVerificaton" style="display:flex; flex-direction: column; justify-content: center; align-items: center; gap:2rem; margin:0.5rem;">
        <img class="logoImgPublicSize" class="w-[70%] md:[50%] lg:w-[30%]" src="../../../../assets/image/logo-black.png">
        <h1 class="loginText  text-[16px] lg:text-[20px] text-[#1a1a1a]">{{"changePassword" | translate}}</h1>
    </div>
    <form [formGroup]="changePasswordForm" #changePasswordNgForm="ngForm" (ngSubmit)="onSubmit()"> 
        <div id="container">

            <div class="child">

                <div class="container-login100-form-btn" style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap:1rem;">
                                     
                        <mat-form-field appearance="outline" class="inputField" style="text-align: center;">
                            <mat-label>{{"Insert verify code" | translate}}</mat-label>
                            <mat-icon matSuffix><i class="fa-regular fa-key"></i></mat-icon>
                            <input class="verify" text="text" [(ngModel)]="verifyCode" maxlength="32" minlength="32" [formControlName]="'verifyCode'" 
                            id="newPassword" matInput required name="verifyCode">
                            <mat-error *ngIf="f['verifyCode'].touched && f['verifyCode'].invalid">
                                <div class="text-[9px]" *ngIf="f['verifyCode'].errors && f['verifyCode'].errors['required']">
                                    {{"Required Field" | translate}}
                                </div>
                            </mat-error>
                            <mat-error>
                                <span class="text-[9px] text-center">{{"The code must be 32 characters" | translate}}</span>
                            </mat-error>
                        </mat-form-field>
                                    

                <mat-form-field appearance="outline" class="inputField">
                    <mat-label>{{"New password" | translate}}</mat-label>
                    <input minlength=8 [(ngModel)]="newPassword" [formControlName]="'newPassword'" id="newPassword" matInput type="password" name="password_1" autocomplete="on"
                         required>
                    <mat-icon matSuffix [ngmodel]="newPassword"><i class="fa-regular fa-lock"></i></mat-icon>
                    <mat-error class="text-[9px] text-center" *ngIf="f['newPassword'].touched && f['newPassword'].invalid">
                            {{"Invalid password (Minimum 6 characters)" | translate}}
                    </mat-error>             
                </mat-form-field>

                <mat-form-field appearance="outline" class="inputField">
                    <mat-label>{{"Confirm New Password" | translate}}</mat-label>
                    <input [formControlName]="'confirmPassword'" minlength=8 [(ngModel)]="confirmPassword" matInput
                    type="password" name="password_2" autocomplete="on" id="confirmPassword" required>
                    <mat-icon matSuffix><i class="fa-regular fa-lock"></i></mat-icon>
                    <mat-error *ngIf="f['confirmPassword'].touched && f['confirmPassword'].invalid">
        
                        <div class="text-[9px] text-center" *ngIf="f['newPassword'].errors && f['newPassword'].errors['required']">{{"Required Field" | translate}}</div>
                        <div *ngIf="f['confirmPassword'].errors && f['confirmPassword'].errors['confirmPasswordValidator']">
                          {{"Password and Confirm Password Mast match" | translate}} 
                        </div>       
                    </mat-error>
                </mat-form-field>
                </div>
            </div>
</div>

        <div>

            <div class="sendMailBtn text-center m-2">
                <button mat-raised-button color="primary" class="wide-button" [disabled]="!changePasswordForm.valid">
                    {{"Save" | translate}}
                </button>
            </div>
        </div>
        <div class="sendMailBtn mt-7 sm:mt-10">
            <button class="sendMailBtnSendNewCode wide-button" type="button" mat-raised-button color="primary" (click)="resendCode()">
              {{"Resend Code" | translate}}
            </button>
          </div>

        <div class="form-group col text-center sm:text-right pt-5 sm:pt-0">
            <a routerLink="/login" class="btn btn-link pr-0 no-padding">{{"Login" | translate}}</a>
        </div>
    </form>

</div>